var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.b(),style:(_vm.styleSizeName)},[(_vm.reload)?_c('div',{style:(_vm.styleSizeName),attrs:{"id":"player-wrapper"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }